import { SearchAllProductsApi, type ProductFilter } from "app/api/product/products.api";
import {
  isTypesenseBrowserConfigured,
  searchTypesenseBrowser,
} from "app/api/typesense/typesense-browser";

/**
 * Prefer direct Typesense from the browser when PUBLIC_TYPESENSE_* is set; otherwise
 * the existing encrypted API (`/products/product-search`).
 */
export async function searchProductCatalogClient(
  params: ProductFilter & { page?: number; signal?: AbortSignal },
): Promise<{
  products: import("app/api/product/product.type").ProductObject[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
    nextPage: number | null;
    prevPage: number | null;
  };
}> {
  if (isTypesenseBrowserConfigured()) {

    return searchTypesenseBrowser({
      search: params.search,
      page: params.page,
      limit: params.limit,
      sort: params.sort,
      minQty: params.minQty,
      minPrice: params.minPrice,
      maxPrice: params.maxPrice,
      colours: params.colours,
      userType: params.userType,
      normalSearch: params.normalSearch,
      nlQuery: params.nlQuery,
      nlModelId: params.nlModelId,
      signal: params.signal,
    });
  }

  const res = await SearchAllProductsApi(params);
  return res.data;
}
